import styled from 'styled-components';
import { Col } from 'react-bootstrap';
import {
  mediaBreakpointDown,
  mediaBreakpointUp,
} from '../../utils/styledCssHelpers';

export const SSection = styled.section`
  margin: ${props => (props.removeMargin ? 'unset' : props.margin || 'unset')};
  padding: ${props => (props.padding ? '5em 0' : 'unset')};
  position: relative;
  overflow: ${props => (props.overflow ? 'hidden' : 'unset')};
  z-index: 0;
  background: ${props =>
    props.mode == 'dark'
      ? props.theme.colors.main
      : props.theme.colors.bg_grey};
`;

export const SCol = styled(Col)`
  position: ${props => props.position};
  ${mediaBreakpointDown(
    'lg',
    `
    display: none;
    
  `,
  )};
`;

export const SSVGHolder = styled.div`
  position: absolute;
  top: 100px;
  left: 290px;

  ${mediaBreakpointDown(
    'xl',
    `
    left: 210px !important;
    top: 70px !important;
    
  `,
  )};

  & svg {
    ${mediaBreakpointDown(
      'xl',
      `
    height: 100px;
    left: 170px !important;
    top: 70px !important;
    
  `,
    )};

    ${mediaBreakpointDown(
      'lg',
      `
    display: none;
  `,
    )};
  }
`;
